module.exports = __webpack_public_path__ + "img/sprite-icon.87fff12d.png";